import instance from './request'
import Vue from 'vue'
export function ddJugeTokenTimeOut() {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/dingding/jugeTokenTimeOut.do',
    method: 'get'
  })
}
export function selectDingdingThird(type, code) {
  return instance({
    url: Vue.prototype.$ysUrl + `/event/dingding/selectDingdingThird.do?type=${type}&userCode=${code}`,
    method: 'get'
  })
}
export function bindDingDingThird(type, code) {
  return instance({
    url: Vue.prototype.$ysUrl + `/event/dingding/bindDingDingThird.do?type=${type}&userCode=${code}`,
    method: 'get'
  })
}

export function DingDingGetUserToken(accountId) {
  return instance({
    url: Vue.prototype.$ysUrl + `/event/dingding/getUserToken.do?accountId=${accountId}`,
    method: 'get'
  })
}

export function menuPermission() {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/menu/permission.do?menu=teaching',
    method: 'get'
  })
}

export function checkNameAndSub() {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/classHour/checkUserNameAndSubject',
    method: 'get'
  })
}

export function applyClassHour(data) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/classHour/applyEventClassHour',
    data,
    method: 'post'
  })
}

export function insertClassHourApply(data) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/classHour/insertEventClassHourApply',
    data,
    method: 'post'
  })
}

export function applyAndAwarded() {
  // 获取用户可申请和已获得学时的活动
  return instance({
    url: Vue.prototype.$ysUrl + '/event/classHour/getMayApplyAndAwardedEventNew',
    method: 'get'
  })
}

export function revokeEventClassHour(params) {
  // 获取用户可申请和已获得学时的活动
  return instance({
    url: Vue.prototype.$ysUrl + '/event/classHour/revokeEventClassHour',
    params,
    method: 'get'
  })
}

export function synOldCertByUser() {
  // 获取用户可申请和已获得学时的活动
  return instance({
    url: Vue.prototype.$ysUrl + '/event/classHour/synOldCertByUser',
    method: 'get'
  })
}

export function userInfoSubject(id) {
  return instance({
    url: Vue.prototype.$ysUrl + `/event/inline/userInfo/teacher/subjects?teacherId=${id}`,
    method: 'get'
  })
}

export function userInfoCancelOrg(accountId, orgId) {
  return instance({
    url: Vue.prototype.$ysUrl + `/event/inline/userInfo/cancel/org/teacher?openAccountId=${accountId}&orgId=${orgId}`,
    method: 'get'
  })
}

export function userInfoApplyOrg(accountId, orgId) {
  return instance({
    url: Vue.prototype.$ysUrl + `/event/inline/userInfo/apply/org/teacher?needApproval=false&openAccountId=${accountId}&orgId=${orgId}`,
    method: 'get'
  })
}

export function userInfoUpdate(data) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/inline/userInfo/teacher/baseinfo/update',
    data,
    method: 'post'
  })
}

export function userInfoSave(data) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/inline/userInfo/teacher/update',
    data,
    method: 'post'
  })
}

export function userInfoUpdateDD(data) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/dingding/updateUserInfo.do',
    data,
    method: 'post'
  })
}

// export function outHistory(data) {
//   return instance({
//     url: Vue.prototype.$ysUrl + '/event/api/out/history.data',
//     data,
//     method: 'get'
//   })
// }

export function outHistory(params) {
  const { pageNo, pageSize } = params
  return instance({
    url: Vue.prototype.$ysUrl + `/event/statistics/optimize/history.data?pageNo=${pageNo}&pageSize=${pageSize}`,
    method: 'get'
  })
}

export function getUserStudyTimeByEvent(eventId) {
  return instance({
    url: Vue.prototype.$ysUrl + `/event/classHour/getUserStudyTimeByEvent?eventId=${eventId}`,
    method: 'get'
  })
}

export function getUserClassHourForSignByEvent(eventId) {
  return instance({
    url: Vue.prototype.$ysUrl + `/event/classHour/getUserClassHourForSignByEvent?eventId=${eventId}`,
    method: 'get'
  })
}

export function getDetailLookRecord(eventId) {
  return instance({
    url: Vue.prototype.$ysUrl + `/event/classHour/getDetailLookRecord?eventId=${eventId}`,
    method: 'get'
  })
}

export function statSimpleDataByType(endTime, pageNo, pageSize, startTime) {
  return instance({
    url: Vue.prototype.$ysUrl + `/event/statistics/selectSimpleDataByType?endTime=${endTime}&pageNo=${pageNo}&pageSize=${pageSize}&startTime=${startTime}&types=4&types=5`,
    method: 'get'
  })
}

export function getClassHourCertPic(params) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/classHour/getCertPic',
    params,
    method: 'get'
  })
}

// == 二部

export function baseUserInfo(params) {
  return instance({
    url: Vue.prototype.$baseUrl + '/base-api/base/api/auth/user/current/detail',
    params,
    method: 'get'
  })
}

export function dictGetByType(params) {
  return instance({
    url: Vue.prototype.$baseUrl + '/base-api/base/api/dict/getByType',
    params,
    method: 'get'
  })
}

export function subjectByGrade(params) {
  return instance({
    url: Vue.prototype.$baseUrl + '/base-api/base/api/external/getSelectSubjectByPeriodId',
    params,
    method: 'get'
  })
}

export function orgFindByName(data) {
  return instance({
    url: Vue.prototype.$baseUrl + '/base-api/base/api/organizationUnit/findOrgByName',
    data,
    method: 'post'
  })
}

export function orgFindAll(params) {
  return instance({
    url: Vue.prototype.$baseUrl + '/base-api//base/api/organizationUnit/all',
    params,
    method: 'get'
  })
}
